import { Directive, Renderer2, ElementRef, OnInit, Input } from '@angular/core';
import { FormGroupDirective, AbstractControl } from '@angular/forms';

@Directive({
  selector: 'form[arsultimaForm]',
})
export class ArsultimaFormDirective implements OnInit {
  @Input('arsultimaForm') parentSelector: string = 'mat-form-field';

  constructor(
    private formGroupDirective: FormGroupDirective,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    const formGroup = this.formGroupDirective.form;

    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);
      const fieldElement = this.el.nativeElement.querySelector(
        `[formControlName="${controlName}"]`,
      );

      if (control && fieldElement && this.hasRequiredValidator(control)) {
        this.renderer.addClass(fieldElement, 'required');

        const parentElement = fieldElement.closest(this.parentSelector);
        if (parentElement) {
          this.renderer.addClass(parentElement, 'required');
        }
      }
    });
  }

  private hasRequiredValidator(control: AbstractControl): boolean {
    // Check if the validator is present in _rawValidators (internal Angular API)
    if ((control as any)._rawValidators) {
      return (control as any)._rawValidators.some(
        (validator: any) => validator.name === 'required',
      );
    }

    // If not, check the control.validator function
    const validator = control.validator ? control.validator({} as any) : null;
    return validator && validator['required'] === true;
  }
}
